import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"ClosedCards"}}
export type ClosedCardsQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type ClosedCardsQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { cards: Array<(
      { __typename: 'Card' }
      & Pick<Types.Card, 'id' | 'closed'>
    )> }
  )> }
);


export const ClosedCardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClosedCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"closed"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}}]}}]}}]}}]};

/**
 * __useClosedCardsQuery__
 *
 * To run a query within a React component, call `useClosedCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClosedCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClosedCardsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useClosedCardsQuery(baseOptions: Apollo.QueryHookOptions<ClosedCardsQuery, ClosedCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClosedCardsQuery, ClosedCardsQueryVariables>(ClosedCardsDocument, options);
      }
export function useClosedCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClosedCardsQuery, ClosedCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClosedCardsQuery, ClosedCardsQueryVariables>(ClosedCardsDocument, options);
        }
export type ClosedCardsQueryHookResult = ReturnType<typeof useClosedCardsQuery>;
export type ClosedCardsLazyQueryHookResult = ReturnType<typeof useClosedCardsLazyQuery>;
export type ClosedCardsQueryResult = Apollo.QueryResult<ClosedCardsQuery, ClosedCardsQueryVariables>;